import { IconReceipt, mapper } from '@maia/icons';
import { QuotationDto } from '@maia/shared';
import { FeaturedIcon, Typography } from '../../../ui';
import { BaseCardProps, CardBase } from './base';

interface QuotationCardProps extends BaseCardProps {
  readonly quotation: QuotationDto;
}

export function QuotationCard(props: QuotationCardProps) {
  const { quotation, ...rest } = props;
  return (
    <CardBase {...rest}>
      <Typography
        variant="body-xs"
        weight="medium"
        className="text-primaryMain"
      >
        {quotation.reference}
      </Typography>
      <div className="flex items-center gap-x-14 flex-grow">
        <FeaturedIcon icon={IconReceipt} variant="light-circle" />
        <div className="flex flex-col">
          <Typography
            variant="body-xs"
            weight="medium"
            className="text-primaryMain"
          >
            {quotation.products.map((p) => p.title).join(', ')}
          </Typography>
          <Typography
            variant="body-xs"
            weight="regular"
            className="text-grayscale300"
          >
            {quotation.customer.consumer.fullName}
          </Typography>
        </div>
      </div>
    </CardBase>
  );
}
